import React from "react";
import { useStores } from "_common/hooks";
import { Link, useNavigate } from "react-router-dom";
import i18next from "i18next";

import HeaderTop from "_common/component/Layout/Header/HeaderTop";

export default function ComingSoon() {
  const navigate = useNavigate();
  const {
    authStore: { questions },
  } = useStores();

  return (
    <div className="min-h-screen overflow-auto bg-[#000000] mt-[70px]">
      <HeaderTop />
      <div className="w-full flex justify-center">
        <img
          className="max-w-[80%] w-96"
          src="https://api.demo92.apptestlive.com/assets/images/coming-soon.svg"
          alt=""
        />
      </div>
    </div>
  );
}
